module.exports = __webpack_public_path__ + "images/sc.a0198b8fb19c3eccd8b34d3fbc30a680.png";